import DualActionButtonPanel from './DualActionButtonPanel';
export default DualActionButtonPanel;